export default {
  /** strings for accessibility features (i.e. VoiceOver) */
  accessibility: {
    types: {
      button: 'button',
      header: 'header',
    },

    refresh: 'refresh',
    refreshHint:
      'Re-fetches the questionnaire and status. The current page will be updated.',

    back: 'back',
    backHint: 'Jumps to previous page.',

    close: 'close',
    closeHint: 'Closes current page or modal.',

    accept: 'accept',
    cancel: 'cancel',
    acceptHint:
      'Switches to default browser application, and opens link there.',

    menu: 'Additional Information',
    menuHint: 'Opens new page with additional information and links.',

    logoutHint: 'Starts logout process and redirects to login page.',
    loginHint: 'Starts login process and redirects to QRCode scanner.',

    questionnaire: {
      middleButtonFinished: 'Next question. question is answered.',
      middleButtonUnfinished:
        'Next question, even though question is not yet answered.',
      middleButtonHint:
        'Jumps to the next questions, or closes the modal if this was the last question.',

      rightButtonHint: 'Jump to the next question.',
      leftButtonHint: 'Jump to previous question.',
      alertButtonHint: 'Close the alert.',

      questionnaireCellHint:
        "Opens new page to see the questionnaire's categories.",
      categoryCellHint: 'Opens modal to fill out this questionnaire entry.',
      category: 'This Category ',
      questionnaire: 'This questionnaire ',
      notStarted: 'has not been answered yet.',
      notFinished:
        "has already been started, but isn't completely filled in yet.",
      finished: 'is fully complete.',

      sendHint: 'Sends the questionnaire to evaluation.',

      multipleChoice:
        'Multiple Choice - more than one answer option can be selected.',
      singleChoice: 'Single Choice - only one answer option can be selected.',
      textFieldHint: 'Please fill in the requested information here.',
      dateFieldHint: 'Opens a new modal to pick a date.',
      sliderFieldEquals: ' equals ',
      sliderFieldAnd: ', and ',

      triggerHint:
        'If this element is selected, another additional question will be shown that is connected to this element. Please fill out the additional question as well.',
      expandCategory: 'show items of this category',
      collapseCategory: 'hide items of this category',

      requiredNotAnswered: 'You have not answered this question yet. Please answer the question to continue.',
      warningNotAnswered: 'You have not answered this question yet. Are you sure you want to proceed to the next question?',
      warningNotAnsweredTitle: 'No Answer Given',
      warningAnswerNow: 'Answer Now',
      warningSkip: 'Skip Question',
      continueFromLastTitle: 'Continue',
      continueFromLast: 'You previously stopped answering the questions. Would you like to continue from where you left off?',
      continueFromLastYes: 'Continue Now',
      continueFromLastNo: 'Cancel',

    },
  },

  /** contains all string rendered on the login-screen, as well as the ones for the landing-screen */
  maintenance: {
    title: 'We’ll be back soon',
    description: 'Umfragetool ACRIBiS is currently undergoing maintenance.',
    body: 'The app is temporarily unavailable during this time. Thank you for your understanding.',
    recovery: 'You can leave this page open. The app will reappear automatically once maintenance is complete.',
    moreInformation: 'More information',
    thanks: 'Thank you for your patience.',
  },

  login: {
    title: 'Login',
    subTitle: '',
    submit: 'Login',
    user: 'subject-id',
    pass: 'password',
    waiting: 'Logging in...',
    btnLogin: 'Login',
    errorPass: 'Please try again.',
    noSubjectId: 'no valid subjectId found',
    errorUserUnauthorized: 'Invalid user data.',
    qrInfo: 'Please point the camera onto the qr-code.',
    errorUserGeneric: 'There occurred a problem during login.',
    permissionCameraTitle: 'Camera access Required',
    permissionCameraExplanation:
        'We need your permission to access the smartphone camera in order to easily scan the access QR code.',
    permissionCameraAlternativeExplanation:
        'Alternatively, you can enter your access ID into the input field. Then tap the "Log In" button.',
    permissionCameraGrant: 'Grant camera access',
    nextStepAfterError: 'Please try to login again later.',
    enterStudyId: 'Enter access code',
    enterAccessCode: 'Please enter your access code into the input field.\nThen click the "Log In" button.',
    enterAccessCodeAlternative: 'Alternatively, you can scan the access QR code using your webcam, if you have received a QR code from us and your computer has a camera:',
    noCamAvailable:  '🎥 Unable to access the webcam stream (please make sure you have an enabled webcam).',
    noQRCodeRecognized: 'No QR code recognized',


    /** contains all strings of the landing-screen */
    landing: {
      buttonText: 'Navigate to Login Screen',
      title: '',
      subTitle: '',
      welcomeTitle: 'Welcome to COMPASS\n(React Native Client)',
      text: "This is the Landing Screen.\n\nIt can be used to display a welcome message, detailing the following login-process, explaining the handling of personal information, etc.\n\nThe logo file (as well as the logoBackground) can be updated by updating the 'CUSTOMIZATION' folder.",
      autoLoginErrorTitle: 'Auto Login Failed',
      autoLoginError:
        'An Error occurred while trying to automatically login. Please check your network and try again',
      retry: 'retry',
      deleteAll: 'Delete all data',
    },
  },

  walkthrough: {
    k1: {
      title: 'Welcome to the ACRIBiS Survey Tool',
      text: 'By participating in the study, you have agreed to complete one or more questionnaires.\n\n' +
          'After successfully logging in to the survey tool, you will find an overview of the questionnaires available to you on the home page.',
    },
    k2: {
      title: 'Completing a Questionnaire',
      text: 'When completing the questionnaire, each entry must be confirmed using the “Next” button.\n\n' +
          'You can pause the questionnaire at any time and continue at a later point. Your responses are saved on the device. In addition, questions that have already been answered are highlighted in blue.',
    },
    k3: {
      title: 'Submitting a Questionnaire',
      text: 'A questionnaire contains so-called “mandatory questions,” which are marked as such. In general, a questionnaire can only be submitted once all mandatory questions have been answered. After submission, the selected or entered responses can no longer be changed.',
    },
    k4: {
      title: 'Available Questionnaires',
      text: 'Please note that additional questionnaires may be made available to you during the course of the study. In this case, you will be notified.\n\n' +
          'For this reason, we kindly ask you to log out of the app or uninstall it only after the study has been completed.',
    }
  },


  /** strings with generic purpose that can be used throughout the application */
  generic: {
    questionnaire: 'Questionnaire',
    mandatoryQuestion: 'Mandatory question',
    ok: 'OK',
    no: 'No',
    yes: 'Yes',
    continue: 'Continue',
    back: 'Back',
    submit: 'Submit',
    confirm: 'Confirm',
    save: 'Save',
    wait: 'Please wait...',
    remainingTime: 'Time remaining',
    minutesShort: 'min.',
    page: 'Page',
    choose: 'Choose',
    error: 'Error',
    abort: 'Cancel',
    warning: 'Warning',
    info: 'Information',
    errorTitle: 'Error',
    successTitle: 'Success',
    delete: 'Yes, delete data',
    goBack: 'Yes, please logout',
    logoutWarning: 'Logout Warning',
    sendSuccess: 'Data sent successfully',
    sendError: 'There was an error transmitting the data. Please try again.',
    sendErrorTwoDevices:
      'You have already sent this questionnaire through another App. ',
    wrongLanguageVersionDetected:
      'The persisted questionnaire does not match the currently selected language on your device. This questionnaire will now be replaced by a matching version. Your answers will be lost.',
    eraseAllWarning:
      'This will delete all local data and logs you out. Do you want to proceed?',
    eraseLocalDataAtEndOfStudyText:
      'This will again emphasize the end of the study. As soon as the user confirms the local data will be removed and the participant is logged out. Do you want to precede?',
    eraseLocalDataAtEndOfStudyTitle: 'Delete local data and logout',
    updateError:
      'An error ocurred while getting the requested data - please try again.',
    infoRemoval:
      'The currently persisted questionnaire is obsolete and will now be removed.',
    reportWhileInIteratedMode:
      'Dialog to tell the user that he already sent in a special report and that he is right now on a special interval.',
    reportWhileQuestionnaire:
      'Dialog to tell the user that currently a questionnaire is available and that he might use that one to report about his condition.',
    allowNotificationsTitle: 'Allow notifications',
    allowNotificationsExplanation: 'We would like to send you notifications to remind you of upcoming questionnaires and events during the course of the study in which you are participating.\n\nIn the next steps, please allow the app to set alarms and reminders, as well as to send notifications.',
    notificationsTitle: 'Benachrichtigungen',
    studyId: 'Study ID',
    skip: 'Skip',
    done: 'Fertig',
    progress: 'Progress',
    close: 'Dismiss',
  },

  /** strings of the about-screen */
  about: {
    title: 'About',
    subTitle: 'About ACRIBiS Survey Tool',
    logout: 'Logout',
    delete: 'Delete stored data & logout',
    demoDelete: 'Delete all & logout (just for this DEMO)',
    languageSelection: 'Language Selection',
    languageWarning:
      'If you change the language while having a persisted save state of your current answers, said save state will be removed.',
    languageWarningAddition: '\nDo you want to proceed?',
    allRightsReserved: 'All rights reserved',
    devNotice: 'Developed by: Institute for Digital Medicine, University Hospital Bonn (UKB)',

    /** contains the strings for the optional LegalInformation Screen */
    legal: {
      title: 'Privacy declaration',
      subTitle:
        'This Links is optionally rendered (can be activated through the development-config). The text-content of that screen can be updated through the text-config',
      iconType: 'entypo',
      iconTitle: 'archive',
    },
    intro: {
      title: 'Introduction',
      subTitle:
          'Short introduction to the app',
      iconType: 'entypo',
      iconTitle: 'help-with-circle',
    },
    bleDevices: {
      title: 'BLE Devices',
      subTitle:
          'Couple with supported devices',
      iconType: 'entypo',
      iconTitle: 'help-with-circle',
    },
    notifications: {
      title: 'Notifications',
      subTitle:
          'Receive app notifications as reminders of upcoming events',
      iconType: 'entypo',
      iconTitle: 'help-with-circle',
    },

  },

  filePicker: {
    chooseFile: "Choose File to Upload",
    dragAndDrop: "Drag and Drop files here or click \"Choose File toUpload\"",
    dropFilesHere: "Drop files here...",
    uploadFiles: "Upload Selected Files"
  },

  /** contains the strings for the legal information screen */
  legalInformation: {
    title: 'Terms of use',
    subTitle: '',
    headline: '',

    content: `DEFINITIONS In this license apply to the interfaces of, the Work is not the case where Apple is the primary copyright notice of copyright, i.e., "Copyright (c) 2001, 2002, 2003, 2004, 2005, 2006 Python Software Foundation; either version 1.3 or later is part of a file documenting the additions, changes or deletions from the Work. If this search is successful, then enquire whether the Work by You alone, not by any Contributor under this Agreement shall terminate as of the following: a) Accompany it with a work which combines Covered Code may contain in whole or in any resulting litigation. Definitions. 1.0.1. "Commercial Use" means distribution or otherwise redistribute the Licensed Product, or for any liability incurred by or claims asserted against, such Contributor as a consequence you may do only in order to apply it to your customers.
					You cannot charge for the Work is distributed to all recipients of Covered Code and executable versions of the Modified Version, and of promoting the sharing and reuse of software distributed under this License. Code" means the original Licensed Product. If you wish while maintaining the availability, integrity, and reliability of that Derived Work under any applicable law.		
					Interpreter' referring to the credit given on this website, or c) through a medium customarily used for display of the Package (7) You may distribute the Source form of the <ORGANIZATION> nor the names of the Source Code. You must duplicate the notice in Exhibit A shall not of themselves be deemed a waiver of future enforcement of that Package while still keeping the Package constitutes direct or contributory patent infringement, then any Derivative Works that You meet the following conditions are met: Redistributions of source code from the Original Code, and keep intact the notices that do not apply to any part thereof, and wants to make the terms applicable to Covered Code. All sublicenses to the work (an example is provided in accordance with the program. It is safest to attach them to the program. It is not confusingly similar phrase do not forfeit any of its terms and conditions of this License, provided that the Program originate from and are distributed by the Licensed Product.		
					This License To use this License which applies to any technical questions or inquiries, or provide any other system and a notice and this permission notice shall be subject to the user community. They therefore concern themselves with the appropriate bodies (for example the POSIX committees). Definitions: "Package" refers to such a notice. If You create or to ask you to surrender the rights.		
					These restrictions translate to certain responsibilities for you to comply with any of the Work that has been certified as open source. It has also been designated as GPL compatible by the Work to which you contribute may be distributed and modified, as well as in related documentation and collateral materials stating that the Program in object code form. This patent license to reproduce, prepare Derivative Works from it. Works" is defined in Article 3 (Restriction) The license granted by this license; they are first used, and the following restrictions: 1.		
					If a component of this License, provided that the Source Code or portions thereof with code not governed by the Contributor, such addition of the Program in a commercial product offering, such Distributor ("Commercial Distributor") hereby agrees to cease use and Distribution of Compiled Forms of the Package, if it fails to comply with the wishes of the software, Licensee agrees to defend claims against the other Contributors related to Product X, those performance claims and warranties, and if a Contributor which are reasonably necessary to make it enforceable. This License complies with the United States and the code itself as a special exception, the source code. And you must rename your license so that distribution is permitted only in or as it is not allowed.		
					You can re-use content from Wikimedia projects freely, with the Licensed Program from such Contributor, if any, must include such Notice in a manner that reasonably allows subsequent Recipients to identify the originator of its Contribution, if any, must include a copy of this License. Artistic License as published by the acts or omissions of such breach; (b) immediately in the copyright notice appear in the name of products derived from the rights conveyed by this License. Provisions which, by their nature, must remain in effect beyond the termination of this License and the following conditions are met: Redistributions of source code as you received as to the Free Software Foundation ("PSF"), and the following disclaimers.		
					Redistributions in source code and object code form. The patent license is also available under the new version. However, only the Licensor or any Contributor, and only if the Program in a commercial product offering, Product X. That Contributor is then produced by applying some process to that Work or a CC-BY-SA-compatible license is granted: 1) for code that you propose to make sure that everyone has such rights, we need to make reasonable conjectures as to name you as the conditions listed in Clause 6 above, in regard to the terms of this Agreement and any Modifications made by someone other than You; and/or (b) to use it for any purpose, but the Licensor or such Contributor (or portions thereof) either on an equitable basis. Nothing herein is intended to facilitate the commercial use of the License published by the parties or the like.`,
  },

  /** strings of the survey-screen */
  survey: {
    subTitle: '',
    logout: 'logout',
    subTitleCheckIn: '',
    title: 'Questionnaire',
    isLoading: 'loading...',
    yourAnswer: 'your answer',
    titleCheckIn: 'Umfragetool ACRIBiS',
    welcomeTitle: 'Welcome',
    noUserTitle: 'User not found',
    sendFinished: 'send questionnaire',
    send: 'Submit your responses',
    additionalAnswer: 'zusätzliche Antwort',
    alternativeAnswer: 'alternative Antwort',
    surveySubTitle: 'To be completed till:  ',
    surveyTitle: 'Your current questionnaire',
    inputPlaceholder: 'please enter your answer',
    endedStudyTitle: 'End of Participation Title',
    noQuestionnaireTitle: 'Questionnaire not found',
    loadingQuestionnaire: 'requesting\nquestionnaire',
    inputPlaceholderTime: 'please enter the date here',
    sessionTimeout: 'Your user could not re recognized',
    reloadingQuestionnaire: 're-loading\nquestionnaire',
    welcomeTitleFirstTime: 'CheckIn-Title for new Users',
    surveyTitleFirstTime: 'Your Entry-Questionnaire Title',
    noUserText: 'Your ID could not be verified. Please try again.',
    welcomeTextFirstTimeUser2:
      ' - See? This is the second part of that message.',
    sendFinishedMessage:
      'confirmation dialog for sending the completed questionnaire?',
    noNewQuestionnaireAvailableYetTitle:
      'Title, in case no Questionnaire is available',
    sendUnfinishedMessageDenied:
      'The current questionnaire is not yet completed. Please do so.',
    endedStudyText:
      'This string will hold information about the end of the study for the user.',
    nextOne:
      'This text will be shown to communicate when the next questionnaire is available: ',
    noQuestionnaireText:
        'An error occurred while loading the questionnaire – please try again.',
    noNewQuestionnaireAvailableYet:
        'There is currently no questionnaire available for you.',
    nextOneNew:
        'There is currently no questionnaire available for you. The next questionnaire will be made available to you on the following day: ',
    noFurtherQuestionnaires:
        'There are no further questionnaires available for you at this time.',
    furtherInfo:
        'We will notify you as soon as another questionnaire becomes available.',
    welcomeTextUser:
        'A questionnaire is currently available for you to complete. Please answer the questions by the specified deadline:',
    welcomeTextFirstTimeUser1:
        'We will notify you as soon as another questionnaire becomes available.',
    invalidInteger: 'Only integers allowed!',
    invalidDecimal: 'Only decimals allowed!',
    invalidTooBig: 'Value has to be smaller than:',
    invalidTooSmall: 'Value has to be larger than:',
    invalidNotEmail: 'Please enter a valid e-mail address.',
    notMatchingPattern: 'Input does not match required input',
    tapHereToStart: 'Start here with filling out the questionnaire.',
    tapOnTitleToStart: 'Tap on a questionnaire title to start completing the questionnaire',
    overviewOfSurveysHint: 'You can view an overview of the questionnaire contents by tapping the arrow to the right of the respective questionnaire title.',
    notCompletedYet: 'Not yet completed',
    lastCompletedOn: 'Last completed on',
    completeNow: 'Please complete now',
    cancelAnswering: 'Cancel Completion',
    cancelAnsweringDescription:  'Do you really want to stop completing the current questionnaire?\n' +
        'Your previous answers will be saved, and you will be returned to the overview page.',
    closeQuestionnaire: 'Close Questionnaire',
    continueAnswering: 'Continue Completion',
    continueSurvey: 'Continue with the survey',
    thanksSurvey: 'Thank You!',

    completedTitle: 'All questions answered',
    completedMessage: 'You have answered all the required questions and can now close the survey.',

    expired: 'The study has expired. If you believe this is an error, please reach out to your designated point of contact.',

    finishedAllTitle: 'Thank you for your participation!',
    finishedAllCloseHint: 'You can now close this page.',

    sliderInputNoSelectionMade: 'You haven\'t made a selection yet.',
    sliderInputNoSelectionMakeSelection1: 'Make your selection on the black line by ',
    sliderInputNoSelectionMakeSelection2: ' at the corresponding position on the line',
    sliderInputNoSelectionMakeSelectionTap: 'tapping',
    sliderInputNoSelectionMakeSelectionClick: 'clicking',
    sliderInputYourSelection: 'Your selection',
    sliderInputCancelSelection: 'Cancel selection',
    sliderInputNoSelectionWantedHint1: 'You prefer not to answer. If you would like to provide an answer after all, make your selection on the black line by ',
    sliderInputNoSelectionWantedHint2: ' at the corresponding position on the line.',
    sliderInputNoSelectionWanted: 'I prefer not to answer',

    sketchUndo: 'Undo',
    sketchClear: 'Clear',
    sketchEraser: 'Eraser',
  },

  /** strings for the special-report-flow */
  reporting: {
    symptoms_no: 'NO',
    symptoms_yes: 'YES',
    symptoms_success_ok: 'Success-Confirmation',
    symptoms_success_header: 'Success-Message-Header',
    symptoms_header: 'Button: Send out Special Report',
    symptoms_success_message: 'Success-Message-Content',
    symptoms_question: 'Insert confirmation question here',
  },

  privacyPolicy: {
    title: 'Datenschutzerklärung',
    subTitle: '',
    content:
      'Diese App wird Ihnen vom Universitätsklinikum Bonn AöR, Venusberg-Campus 1, 53127 Bonn (nachfolgend "wir" oder „uns“) zur Verfügung gestellt. Bei der Nutzung dieser App werden von uns unter Umständen auch personenbezogene Daten erhoben, verarbeitet und genutzt. Weil uns der Schutz Ihrer Privatsphäre bei der Nutzung der App wichtig ist, möchten wir Sie mit den nachfolgenden Informationen darüber informieren, welche Ihrer personenbezogenen Daten erhoben werden, wenn Sie die App nutzen und wie wir mit diesen Daten umgehen. Sie können diese Datenschutzerklärung jederzeit unter <privacy_url>{{privacy_url}}</privacy_url> abrufen. Viele rechtliche Grundlagen für unsere Datenverarbeitung finden sich in der europäischen Datenschutzgrundverordnung (DSGVO), deren Text und die zugehörigen Erwägungsgründe die Sie z.B. <dsgvo_ch_1>hier</dsgvo_ch_1> finden können. In den nachfolgenden Hinweisen verweisen wir auf entsprechende Vorschriften als jeweilige Rechtsgrundlage unserer Verarbeitung.\n\n' +
      '<header>1. Verantwortliche Stelle/Kontakt, Beschwerden</header>\n\n' +
      'Verantwortliche Stelle im Sinne der Datenschutzgesetze (vgl. Art. 4 Nr. 7 DSGVO) ist das Universitätsklinikum Bonn AöR, Venusberg-Campus 1, 53127 Bonn. Sollten Sie Fragen oder Anregungen zum Datenschutz haben, können Sie sich per E-Mail an datenschutz@ukbonn.de wenden. Sie haben zudem, wenn wir Ihr Anliegen aus Ihrer Sicht nicht angemessen behandeln u.a. (Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs) ein Beschwerderecht bei der für den Datenschutz zuständigen Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes.\n\n' +
      'Verantwortlicher für die Datenverarbeitung in Rahmen der Nutzung dieser App ist das\n\n' +
      'Universitätsklinikum Bonn (AöR)\n' +
      'Venusberg-Campus 1\n' +
      '53127 Bonn\n' +
      'E-Mail: researchdata@ukbonn.de\n\n'+
      'Datenschutzbeauftragter\n' +
      'Achim Flender\n' +
      'E-Mail: datenschutz@ukbonn.de\n\n' +
      'Wir sind Verantwortliche im Sinne der Datenschutzgesetze (vgl. Art. 4 Nr. 7 DSGVO). Sollten Sie Fragen zum Datenschutz haben, können Sie sich über die oben genannten Kontaktmöglichkeiten direkt an uns wenden.  Sie haben zudem, wenn wir Ihr Anliegen aus Ihrer Sicht nicht angemessen behandeln, u.a. (Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs) ein Beschwerderecht bei der für den Datenschutz zuständigen Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes.\n\n' +
      '<header>2. Gegenstand des Datenschutzes</header>\n\n' +
      'Gegenstand des Datenschutzes sind personenbezogene Daten. Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person (im Folgenden „betroffene Person“) beziehen. Für die Identifizierbarkeit ist nicht unbedingt eine Namensangabe erforderlich. Es reicht auch eine indirekte Identifizierbarkeit aus, z.B. mittels Zuordnung zu einer Kennnummer, zu Standortdaten, zu einer Online-Kennung oder zu einem oder mehreren besonderen Merkmalen. Es geht also um Ihre Identität. Hierunter fallen beispielsweise Ihr Name, aber auch Ihre Telefonnummer, Ihre Anschrift, sowie andere Daten, die Sie uns mitteilen\n\n' +
      '<header>3. Art und Umfang der erhobenen Daten</header>\n\n' +
      '<subheader>Umfragedaten</subheader>\n' +
      'Im Rahmen der Nutzung der App nehmen Sie an Umfragen im Rahmen von klinischen oder sonstigen wissenschaftlichen Studien, Umfragen zu Qualitätsverbesserungsmaßnahmen oder sonstigen administrativen Umfragen teil. Einer Teilnahme setzt stets eine Einladung von der jeweiligen Studienkoordination voraus, bzw. von dem/der jeweiligen Autor:in der Umfrage. Dabei werden folgende Kategorien von Daten verarbeitet:\n\n' +
      '<item><strong>Inhaltliche Angaben:</strong> Wir erfassen die Antworten, die Sie aktiv in die bereitgestellten Formulare eingeben. Hierzu zählen insb. Daten über Ihren gesundheitlichen und psychischen Zustand, aktuelle Diagnosen, historische Diagnosnen, medizinische Vorgeschichte, und sonstige für die jeweilige Studie relevanten Daten. Zur Erreichung der Forschungsziele erhebt die App ggf. Sensordaten. Dies umfasst</item>\n\n' +
      '<subitem><strong>geräteinterne Sensoren:</strong> (wie z.B. Beschleunigungssensor, Gyroskop, Schrittzähler) Ihres Smartphones, sowie,</subitem>\n\n'+
      '<subitem><strong>externe Sensoren (Wearables):</strong> Sofern Sie ein kompatibles Endgerät (z. B. Fitness-Tracker, Brustgurt) via Bluetooth verbinden, erhebt die App (z. B. Herzfrequenz, Herzratenvariabilität, Sauerstoffsättigung).</subitem>\n\n' +
      '<item><strong>Art der Erhebung:</strong> Die Umfragen erfolgen entweder anonymisiert, pseudonymisiert oder identifiziert, abhängig vom Zweck der Studie und der jeweiligen Umfrage. Hierüber werden Sie von der jeweiligen Studienleitung, bzw. dem/der Autor:in der Umfrage gesondert informiert.</item>\n\n'+
      '<item><strong>Zweck der Befragung:</strong> Die Verarbeitung dient, je nach Kontext, der wissenschaftlichen Forschung, der wissenschaftlichen Auswertung zur Verbesserung der Patientenversorgung am Universitätsklinikum Bonn, oder sonstigen Erkenntnisgewinnung.</item>\n\n' +
      'Wir speichern Ihre personenbezogenen Daten nur so lange, wie es für die Erreichung der Forschungszwecke erforderlich ist oder wie es die gesetzlichen Aufbewahrungsfristen vorsehen:\n\n' +
      '<item><strong>Studienbegleitende Daten:</strong> Personenbezogene Daten (z. B. Ihre Einwilligungserklärung) werden gemäß den berufsrechtlichen Vorschriften für Ärzte sowie den Leitlinien zur Sicherung guter wissenschaftlicher Praxis in der Regel für 10 Jahre nach Abschluss der Studie aufbewahrt. Gemäß dem Zweck der Befragung bzw. der wissenschaftlichen Studie kann die Speicherfrist hiervon abweichen, hierüber werden Sie gesondert informiert.</item>\n\n' +
      '<item><strong>Anonymisierte Daten:</strong> Sobald die Daten vollständig anonymisiert wurden (d. h. ein Rückschluss auf Ihre Person dauerhaft ausgeschlossen ist), unterliegen sie nicht mehr den Regelungen der DSGVO und können für unbegrenzte Zeit zu Forschungszwecken weiterverwendet werden.</item>\n\n' +
      '<item><strong>Widerruf:</strong> Im Falle eines Widerrufs Ihrer Einwilligung werden Ihre Daten umgehend gelöscht, sofern der Anonymisierungsprozess noch nicht abgeschlossen ist und keine gesetzlichen Aufbewahrungspflichten einer Löschung entgegenstehen.</item>\n\n' +
      '<subheader>Anonymisierte Datenerhebung</subheader>\n' +
      'Zum Schutz unserer IT-Systeme und anderer Nutzer speicher wir für 7 Tage ab der Nutzung Ihre IP-Adresse (Rechtsgrundlage Art. 6 Abs. 1 lit f DSGVO), um ggf. in Zusammenarbeit mit Behörden und unter Einschaltung von Gerichten Angriffen zu begegnen und diese verfolgen zu können.\n\n' +
      '<subheader>Datennutzung zur Leistungserbringung</subheader>\n\n' +
      '<subheader>Gesonderte Einwilligung</subheader>\n'+
      'Sie können Ihre Einwilligung zur Nutzung der Standortdaten jederzeit widerrufen, indem Sie den Zugriff der App auf Ihre Standortdaten in den Einstellungen der App oder Ihres Endgeräts deaktivieren. Dann können Sie jedoch die Ortungs- und Navigationsfunktion der App nicht mehr nutzen. Der Widerruf von Einwilligungen wirkt für die Zukunft. Die Rechtmäßigkeit der Datenverarbeitung in der Vergangenheit bleibt unberührt.\n\n' +
      '<subheader>Datennutzung Ihrer Rückmeldungen, Kontaktaufnahmen</subheader>\n'+
      'Wenn Sie uns Rückmeldungen zur App geben, etwa über Formulare innerhalb der App oder sonst Meldungen zur App übermitteln, speichern und nutzen wir diese Daten zur Verbesserung der App und ihrer Funktionen.\n Wenn wir in diesem Zusammenhang Ihren Namen und/oder Ihre E-Mail-Adresse erhalten oder deren Angabe erbitten, so nutzen wir diese allein zur Kommunikation mit Ihnen im Rahmen Ihres Anliegens.\n\n Nehmen Sie über unsere Kontaktmöglichkeiten (z.B. über E-Mail oder das Kontaktformular) Kontakt mit uns auf, speichern wir Ihren Namen und Ihre Kontaktdaten sowie Ihr Anliegen. Die Daten werden verwendet, um Ihr Anliegen zu bearbeiten und mit Ihnen zu kommunizieren. Sie können in allen Fällen statt Ihres Namens auch ein Pseudonym angeben, es sei denn der Name ist für die Erledigung Ihres Anliegens notwendig. Hat sich Ihr Anliegen endgültig erledigt und bestehen keine sonstigen Aufbewahrungspflichten, werden die Daten wieder gelöscht. Rechtsgrundlage für die entsprechenden Datennutzungen ist Art. 6 Abs. 1 Satz 1 lit b DSGVO. Die Kommunikation über das Feedback-Formular erfolgt verschlüsselt.\n\n' +
      '<header>4. Push-Notifications</header>\n\n'+
      'Sie können uns die Erlaubnis erteilen, sog. Push-Notifications, also Mitteilungen auf Ihrem Gerät anzuzeigen. Hierbei kann es sich um Angebote, spezielle Erinnerungen oder sonstige Hinweise handeln. Wenn wir diese Funktion anbieten, werden wir Sie nach Ihrer Erlaubnis fragen. Sie können auch nach Erlaubniserteilung die Push-Notifications jederzeit in den Geräteeinstellungen deaktivieren. Die Rechtsgrundlage für diese Datenverarbeitung ist Ihre Einwilligung gem. Art. 6 Abs. 1 Satz 1 lit. a DSGVO.\n\n' +
      '<header>5. Datensicherheit</header>\n\n'+
      'Wir verschlüsseln den Datenaustausch zwischen der App und unseren Systemen während der Nutzung per TLS.\n\n' +
      '<header>6. Deinstallation und Löschung von Daten</header>\n\n'+
      'Wir speichern keine Daten zu Ihrer Person oder zu einem für uns auf Ihre Person rückführbaren Kennzeichen mit Ausnahme der von Ihnen veranlassten Kontaktanfragen (vgl. oben „Datennutzung Ihrer Rückmeldungen, Kontaktaufnahmen“ dort zur Löschung). Beachten Sie bitte, dass eine Deinstallation der App auf Ihrem Gerät nicht automatisch zur Löschung Ihrer personenbezogenen Daten aus Ihren Anfragen auf unserem Server führt. Sie können Ihre Daten aber jederzeit löschen lassen, indem Sie Ihren Nutzungsvertrag mit uns kündigen.\n\n' +
      '<header>7. Ihre Rechte</header>\n\n'+
      'Sie haben das Recht auf Auskunft (inklusive unentgeltlicher Überlassung einer Kopie) über Ihre, im Rahmen der Studie erhoben und verarbeitet personenbezogenen Daten. Außerdem können Sie die Berichtigung unzutreffender Daten, die Löschung oder die Einschränkung der Verarbeitung Ihrer Daten verlangen.\n\n'+
      '<strong>Sie können Ihre Einwilligung jederzeit widerrufen ohne dass Ihnen dadurch Nachteile entstehen.</strong> Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der, aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.\n\n' +
      '<header>8. Kontaktdaten des Datenschutzbeauftragten</header>\n\n'+
      'Achim Flender\n'+
      'Universitätsklinikum Bonn - Anstalt des öffentlichen Rechts\n'+
      'Venusberg-Campus 1\n'+
      '53127 Bonn\n\n'+
      'E-Mail: datenschutz@ukbonn.de\n'+
      'Telefon: 0228 – 287 160 75\n\n' +
      '<header>9. Beschwerderecht bei der Aufsichtsbehörde:</header>\n\n'+
      'Sie haben jederzeit das Recht, sich an die zuständige Aufsichtsbehörde zu wenden:\n\n'+
      'Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen\n'+
      'Kavalleriestr. 2-4, 40213 Düsseldorf\n'+
      'E-Mail: poststelle@ldi.nrw.de, Telefon: 0211 – 384 24-0\n\n' +
      '<header>10. Änderungen dieser Datenschutzerklärung</header>\n\n'+
      'Wir halten diese Datenschutzerklärung immer auf dem neuesten Stand. Deshalb behalten wir uns vor, sie von Zeit zu Zeit zu ändern und Änderungen bei der Erhebung, Verarbeitung oder Nutzung Deiner Daten nachzupflegen. Die aktuelle Fassung der Datenschutzerklärung ist stets unter <privacy_url>{{privacy_url}}</privacy_url> abrufbar. \n\n'+
      'Stand: Juni 2026 ',
  },

  dateTimePicker: {
    time: 'Time',
    hour: 'Hr.',
    minute: 'Min.',
    second: 'Sec.',
    sum_max: 'The total input must not exceed {{max}}.\n',
    sum_min: 'The total input must be at least {{min}}.\n',
    max: 'The input must not exceed {{max}}.\n',
    min: 'The input must be at least {{min}}.\n',
    months: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    select_date: 'Please select date',
    pick_date: 'Select date'
  },

  /** each entry in this array will generate a new listItem on the about-screen. When clicked on such an item, a webView will open that
   * can display any website. "iconType" is the name of a free Webfont and the title is the name of the particular icon. .
   * as this app is using react-native-elements, the list of compatible fonts can be found in its documentation:
   * https://reactnativeelements.com/docs/icon
   */
  webViews: [
    {
      title: 'Imprint',
      subTitle:
          ' ',
      screenSubTitle: '',
      uri: 'https://www.ukbonn.de/impressum/',
      iconTitle: 'info',
      iconType: 'entypo',
    },
    {
      title: 'Privacy declaration',
      subTitle:
          ' ',
      screenSubTitle: '',
      uri: 'Privacy',
      iconTitle: 'suitcase',
      iconType: 'entypo',
    },
    {
      title: 'Terms of use',
      subTitle:
          ' ',
      screenSubTitle: '',
      uri: 'Terms',
      iconTitle: 'suitcase',
      iconType: 'entypo',
    },
  ],

  /** each entry in this array will generate a new listItem on the about-screen. When clicked on such an item, a modal will open
   * that informs the user that he/she is being redirected to their local browser. "iconType" is the name of a free Webfont and the title is the name of the particular icon. .
   * as this app is using react-native-elements, the list of compatible fonts can be found in its documentation:
   * https://reactnativeelements.com/docs/icon
   */
  modalLinks: [
    // {
    //   title: 'First Link',
    //   subTitle:
    //     'This is a regular link. It will open a modal before redirecting the user to his/her own browser.',
    //   text: 'your are now being redirected.',
    //   uri: 'https://github.blog/',
    //   iconTitle: 'link',
    //   iconType: 'entypo',
    // },
    // {
    //   title: 'Second Link',
    //   subTitle:
    //     "For each item you add to the 'modalLinks' property of textConfig.js another entry in this list is generated.",
    //   text: 'your are now being redirected.',
    //   uri: 'https://ibm.com/',
    //   iconTitle: 'link',
    //   iconType: 'entypo',
    // },
  ],
};
